import React, { useContext, useEffect, useState } from "react";
import { ReactComponent as CloseModal } from "../../assets/close-day.svg";
import { ReactComponent as Logo } from "../../assets/logo-day.svg"; // Add your logo file
import { Link } from "react-router-dom";
import CookieManager from "../../services/CookieManager";
import "./style.css";
import TrackContext from "../../contexts/track-context";


import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import SubscriptionsOutlinedIcon from '@mui/icons-material/SubscriptionsOutlined';
import GraphicEqOutlinedIcon from '@mui/icons-material/GraphicEqOutlined';
import FlareOutlinedIcon from '@mui/icons-material/FlareOutlined'; 
import ZoomInOutlinedIcon from '@mui/icons-material/ZoomInOutlined';
import LibraryMusicOutlinedIcon from '@mui/icons-material/LibraryMusicOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import QueueMusicIcon from '@material-ui/icons/QueueMusic';

import PersonIcon from '@mui/icons-material/Person';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';

import { useHistory } from "react-router-dom/cjs/react-router-dom";


function MobileMenu(props) {
  let userData = JSON.parse(CookieManager.getCookie("user-data"));
  let trackContext = useContext(TrackContext);
  
  const handleMobileSearch = () => {
    props.setShowProjectModal(true);
    props.handleMobileMenuClose();
  };

  const handleSignoutClick = () => {
    trackContext.setShowLogoutPopup(true);
    props.handleMobileMenuClose();
  };

  const history=useHistory();

  function cx(...a) {
    return a.filter(Boolean).join(" ");
  }

  const [links, setLinks] = useState([
    { label: "Music", url: "/library" },
    { label: "SFX", url: "/sfx" },
    { label: "Now Out", url: "/new-inspiration" },
    { label: "Labels", url: ["/catalogs", "/catalog/albums/"] },
    { label: "Pricing", url: "/home#card-container" },
    { label: "About", url: "/about" },
    { label: "Support", url: "/contact" },
    userData != null && { label: "Sign out", }
  ]);
  
  const getIcon = (label) => {
    if(label?.length > 0){
      switch(label){
        case "Music" :
          return <ZoomInOutlinedIcon style={{fontSize : "30px"}} />
        case "SFX" :
          return <GraphicEqOutlinedIcon style={{fontSize : "30px"}} />
        case "Now Out" :
          return <QueueMusicIcon style={{fontSize : "30px"}} />
        case "Labels" :
          return <LibraryMusicOutlinedIcon style={{fontSize : "30px"}} />
          
        case "Pricing" :
          return <RequestQuoteIcon style={{fontSize : "30px"}} />
        case "About" :
          return <InfoOutlinedIcon style={{fontSize : "30px"}} />
        case "Support" :
          return <ChatBubbleOutlineIcon style={{fontSize : "30px"}} />
        case "Sign out" :
          return <LogoutOutlinedIcon style={{fontSize : "30px"}} />

        
          default :
            return <></>
      }
    }
  }

  const path = window.location.pathname;
  useEffect(() => {
      if(path?.length > 0){
        const tempLinks = links.flatMap(e => {
          if(e?.label?.length > 0){
            e.active = getActiveStatus(path, e?.url);
            return e;
          }else
            return [];
        });
        setLinks([...tempLinks])
  
      }
    }, [path])
  
    const getActiveStatus = (path, url) => {
      let status = false;
      if(url?.length > 0 && path?.length > 0){
        if(Array.isArray(url)){
          url.forEach(e => {
            if(path.includes(e)){
              status = true;
            }
          })
        }else{
          status = path.includes(url);
        }
      }
      return status;
    }
    useEffect(() => {
  
    },[links])

  return (
    <aside className="lg:hidden fixed top-0 right-0 overflow-hidden h-100 w-50 bg-white text-black rounded-2xl" style={{width : "50%", boxShadow : "0px 3px 10px rgba(var(--shadow))", zIndex : 10000}}>
      {/* Top Section with Logo and Close Button */}
      <div className="flex justify-end items-center px-4 pt-4">
        {/* <Logo className="h-14" />  */}
        <CloseModal
          className="cursor-pointer  w-6 h-6"
                    onClick={props.handleMobileMenuClose}
        />
      </div>
      
      {/* Menu Items */}

      <div className="space-y-1.5">
        {links.map((item) => (
          <button
            key={item.label}
            type="button"
            className={cx(
              "flex w-full items-center gap-2 rounded-xl px-3 py-3 text-center transition cursor-pointer hover:bg-gray-200",
              item.active
                ? "bg-pink-50 text-pink-900"
                : "text-black"
            )}
            onClick={() => {item.url?.length > 0 ? history.push(Array.isArray(item.url) ? item.url[0] : item.url) : trackContext.setShowLogoutPopup(true); props.handleMobileMenuClose()}}
            style={{background : item.active ? "#ffd7e8" : "white", color : item.active ? "rgb(var(--pink))" : "black"}}
          >
            <span className="my-2 ml-2">{getIcon(item.label)}</span>
            <span className="menu-title mr-2" 
              style={{background : item.active ? "#ffd7e8" : "white", color : item.active ? "rgb(var(--pink))" : "black"}}>
              {item.label}
            </span>
          </button>
        ))}
      </div>

    </aside>
  );
}

export default MobileMenu;
